<template>
  <div>{{ $t('white-label.globalMessages.agGridNoRowsText') }}</div>
</template>
<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'no-rows-overlay-renderer'
});
</script>
